import { useGetApplys } from "@api";
import { Box, CircularProgress, FormControl, FormHelperText, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect } from "react";
import { type Control, Controller, useWatch } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver, TModalAction } from "../../../logics/types";
import { ActionModalFieldApplyItem } from "./item";
import { getApplyTitle } from "./logics";

export interface IModalActionFormApplyProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
  action?: TModalAction;
}

export const ModalActionFormApply = ({ control, action }: IModalActionFormApplyProps) => {
  const [{ data: appliesData, loading: loadindApplies }, getApplies] = useGetApplys();
  const candidate = useWatch({
    control,
    name: "candidate",
  });

  useEffect(() => {
    try {
      if (candidate) {
        void getApplies({
          kind: "job",
          candidate: candidate._id,
          processed: true,
          applicable: true,
          status: ["success"],
          sort: { updatedAt: -1, scoring: -1, travelTime: -1 },
          limit: 0,
        });
      }
    } catch (e) {
      console.error(e);
    }
  }, [candidate, getApplies]);

  return (
    <Controller
      control={control}
      name="jobFollowUp.apply"
      render={({ field: { value, onChange, onBlur, ref }, fieldState: { error } }) => (
        <FormControl disabled={!candidate || (Boolean(action?._id) && Boolean(action?.apply))} size="small" fullWidth>
          <InputLabel id="modal-action-job-follow-up-apply-label">Embauche liée *</InputLabel>
          <Select
            labelId="modal-action-job-follow-up-apply-label"
            label="Embauche liée *"
            id="modal-action-job-follow-up-apply"
            value={appliesData ? value : ""}
            onChange={onChange}
            onBlur={onBlur}
            inputRef={ref}
            error={Boolean(error)}
            renderValue={(p) => p && getApplyTitle(p, appliesData)}
            endAdornment={
              loadindApplies ? (
                <Box sx={{ mr: 3, mt: 0.5 }}>
                  <CircularProgress size={20} color="primary" />
                </Box>
              ) : null
            }
          >
            {appliesData && appliesData.count > 0 ? (
              appliesData?.data.map((apply) => (
                <ActionModalFieldApplyItem key={apply._id} apply={apply} value={apply._id} />
              ))
            ) : (
              <MenuItem disabled>Aucune embauche pour ce candidat</MenuItem>
            )}
          </Select>
          <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  );
};
